import {
  convertDateToYYYYMMDDFormat,
  convertEventSelectToTarget,
  CustomDateRangePicker,
  formatDataToLabelValue,
  FormFeedBack,
  PageWrapper,
  parseLocalDateFromYYYYMMDD,
  Select,
  STATUSPAGE,
  SUBMIT_BUTTON,
} from '@repo/ui';
import { useProfessionalsWorkJourney } from 'presentation/app/modules/Reports/hooks/useProfessionalsWorkJourney';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Spinner,
} from 'reactstrap';

import { WorkJourneyGroupedList } from './components/work-journey-grouped-list';

const ProfessionalsWorkJourney = () => {
  const {
    validation,
    coursesUser,
    tableLoading,
    buttonsLoading,
    hasFetchedData,
    workJourneyData,
    organizationsUser,
    professionalsLoading,
    selectedSubmitBtnRef,
    requestGetAllCoursesUser,
    professionalsSelectOptions,
  } = useProfessionalsWorkJourney();

  return (
    <PageWrapper title="Relatório Profissionais > Jornada de Trabalho">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Relatorio Jornada de Trabalho</h4>
      </Col>

      <Card>
        <Form
          autoComplete="off"
          onSubmit={(event) => {
            event.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <CardBody>
            <Row>
              <Col xs={12} md={4} lg={4} className="mb-3">
                <Label htmlFor="entity" className="form-label">
                  Organização:
                </Label>
                <Select
                  isClearable
                  id="entity"
                  name="entity"
                  placeholder="Todas as Organizações"
                  value={validation.values.entity}
                  onChange={(e) => {
                    requestGetAllCoursesUser(e?.value || '');
                    validation.setValues({
                      ...validation.values,
                      course: null,
                      professionals: [],
                    });

                    validation.handleChange(
                      convertEventSelectToTarget('entity', e),
                    );
                  }}
                  invalid={!!(validation.touched && validation.errors?.entity)}
                  onBlur={validation.handleBlur}
                  options={formatDataToLabelValue(
                    organizationsUser as never,
                    'id',
                    'nome',
                  )}
                />
                <FormFeedBack
                  error={validation.errors?.entity?.toString()}
                  isInvalid={
                    !!(validation.touched && validation.errors?.entity)
                  }
                />
              </Col>

              <Col xs={12} md={4} lg={4} className="mb-3">
                <Label htmlFor="course" className="form-label">
                  Curso:
                </Label>
                <Select
                  isClearable
                  id="course"
                  name="course"
                  placeholder="Todos os Cursos"
                  value={validation.values.course}
                  onChange={(e) => {
                    validation.setValues({
                      ...validation.values,
                      professionals: [],
                    });

                    validation.handleChange(
                      convertEventSelectToTarget('course', e),
                    );
                  }}
                  invalid={!!(validation.touched && validation.errors?.course)}
                  onBlur={validation.handleBlur}
                  options={formatDataToLabelValue(
                    coursesUser as never,
                    'id',
                    'nome',
                  )}
                />
                <FormFeedBack
                  error={validation.errors?.course?.toString()}
                  isInvalid={
                    !!(validation.touched && validation.errors?.course)
                  }
                />
              </Col>

              <Col xs={12} md={4} lg={4} className="mb-3">
                <Label htmlFor="professionals" className="form-label">
                  Profissional:
                </Label>
                <Select
                  isMulti
                  isClearable
                  id="professionals"
                  name="professionals"
                  isLoading={professionalsLoading}
                  isDisabled={professionalsLoading}
                  placeholder="Todos os Profissionais"
                  value={validation.values.professionals}
                  onChange={(e) => {
                    validation.setFieldValue('professionals', e || []);
                  }}
                  onBlur={validation.handleBlur}
                  options={formatDataToLabelValue(
                    professionalsSelectOptions as never,
                    'id',
                    'name',
                  )}
                />
                <FormFeedBack
                  error={validation.errors?.professionals?.toString()}
                  isInvalid={
                    !!(validation.touched && validation.errors?.professionals)
                  }
                />
              </Col>

              <Col sm={12} md={6} lg={4} className="mb-3">
                <Row>
                  <Label htmlFor="initial-date" className="form-label">
                    Período
                  </Label>
                  <CustomDateRangePicker
                    initialStartDate={parseLocalDateFromYYYYMMDD(
                      validation.values.starts,
                    )}
                    initialEndDate={parseLocalDateFromYYYYMMDD(
                      validation.values.ends,
                    )}
                    placement="auto"
                    onDateChange={(start, ends) => {
                      validation.setFieldValue(
                        'starts',
                        convertDateToYYYYMMDDFormat(start),
                      );
                      validation.setFieldValue(
                        'ends',
                        convertDateToYYYYMMDDFormat(ends),
                      );
                    }}
                  />
                </Row>
              </Col>
            </Row>
          </CardBody>

          <CardFooter>
            <div className="w-100 d-flex gap-2 justify-content-end align-content-end">
              <Button
                id="search-button-json"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.JSON;
                }}
                color="primary"
                type="submit"
                disabled={buttonsLoading === STATUSPAGE.LOADING}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </Button>
              <Button
                id="export-pdf"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.PDF;
                }}
                color="light"
                type="submit"
                disabled={buttonsLoading === STATUSPAGE.LOADING}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </Button>
              <Button
                id="save_button"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.EXCEL;
                }}
                color="light"
                type="submit"
                disabled={buttonsLoading === STATUSPAGE.LOADING}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ms-2 ri-file-excel-2-line"></i>
                  </>
                )}
              </Button>
            </div>
          </CardFooter>
        </Form>
      </Card>

      <Card className="mt-3">
        {(hasFetchedData || tableLoading === STATUSPAGE.LOADING) && (
          <CardBody>
            <WorkJourneyGroupedList
              organizations={workJourneyData.data}
              loading={tableLoading === STATUSPAGE.LOADING}
            />
          </CardBody>
        )}
      </Card>
    </PageWrapper>
  );
};

export default ProfessionalsWorkJourney;
